var _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgCatBadgeActive = function SvgCatBadgeActive(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    },
    viewBox: "0 0 24 24"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#FF9",
    d: "M2.895 8.999c-.213-.925.862-1.598 1.601-1.003L6.612 9.7a1 1 0 0 0 1.496-.285l2.772-4.883a1 1 0 0 1 1.74 0l2.772 4.883a1 1 0 0 0 1.496.285l2.116-1.704c.739-.595 1.813.078 1.601 1.003l-2.344 10.225a1 1 0 0 1-.974.776H6.213a1 1 0 0 1-.974-.776z"
  })));
};
export default SvgCatBadgeActive;